import { useMemo } from 'react'
import type { NodeMoreOpItem } from './types'

export type OpMenuCategory =
  | 'image'
  | 'text'
  | 'audio'
  | 'video'
  | 'gallery'
  | 'text-list'
  | 'audio-list'
  | 'video-list'

export type CategorizedOps = Record<OpMenuCategory, NodeMoreOpItem[]>

export function useCategorizedOpMenu(ops: NodeMoreOpItem[], _sourceNodeType: string): CategorizedOps {
  return useMemo(() => {
    const categories: CategorizedOps = {
      image: [],
      text: [],
      audio: [],
      video: [],
      gallery: [],
      'text-list': [],
      'audio-list': [],
      'video-list': [],
    }

    for (const op of ops) {
      const category = op.nodeType as OpMenuCategory
      if (categories[category]) {
        categories[category].push(op)
      }
    }

    return categories
  }, [ops])
}
